export default "__VITE_ASSET__99o2rbFT__"